const regex = /^\.?\d+(\.\d+)*$/;

export default {
  fn: (value) => regex.test(value),
  message: 'You must enter a valid OID'
};
